// extracted by mini-css-extract-plugin
export default {"button":"MoreButton_button__Fxgh8","icon":"MoreButton_icon__btGZC"};